"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function TradeAssurance(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#FACE32", d: "M52.268 5.564V14.5h-9.784V2.637L32 0 21.516 2.636V14.5h-9.784V5.565L1.592 8.65l2.644 46.703L32 64l27.764-8.647L62.408 8.65z" }),
    _react2["default"].createElement("path", { fill: "#FFF", d: "M35.643 40.64c0-1.067-.33-1.934-.993-2.603-.66-.668-1.808-1.29-3.438-1.866-2.635-.893-4.587-1.948-5.856-3.16s-1.902-2.918-1.902-5.112c0-2.084.61-3.766 1.83-5.047 1.218-1.28 2.906-2.05 5.064-2.307v-4.008h2.942v4.044c2.145.318 3.797 1.203 4.955 2.656 1.16 1.453 1.738 3.423 1.738 5.91h-4.45c0-1.568-.338-2.79-1.012-3.667-.673-.877-1.623-1.316-2.85-1.316-1.274 0-2.217.328-2.83.984-.614.656-.92 1.56-.92 2.712 0 1.078.32 1.94.956 2.583s1.826 1.272 3.567 1.885c2.635.944 4.572 2.013 5.81 3.208 1.238 1.196 1.857 2.884 1.857 5.066 0 2.157-.635 3.858-1.904 5.102s-3.037 1.982-5.304 2.216v3.584H29.98v-3.567c-2.233-.233-4.05-1.02-5.454-2.362-1.403-1.343-2.105-3.374-2.105-6.095h4.47c0 1.777.42 3.03 1.26 3.76.84.73 1.908 1.094 3.208 1.094 1.385 0 2.445-.325 3.18-.975.738-.65 1.105-1.556 1.105-2.72z" })
  );
}

exports["default"] = TradeAssurance;
module.exports = exports["default"];